import React,{useContext} from 'react';

import Utils from '../../Utils';
import StepUploadFile from './StepUploadFile';
import StepUploadVideo from './StepUploadVideo';
import Step3 from './Step3';
import StepCustomTemplate from './StepCustomTemplate';
import StepLibrary from './StepLibrary';
import UserContext from './../../contexts/UserContext';
import _ from 'lodash';

const Step2 = (props) => {
  const stepData = props.stepData;
  const {getPkgSize} = useContext(UserContext);

  const onUploadVideo = (fname, file_size) => {            
    props.onUpload({...stepData, step:3, slides: [{
      sid: 1, 
      type: 'Video', 
      data:{
        mode: 'upload',
        link: Utils.apiUrl(`file?f=${fname}`), 
        vid: fname, 
        title: '',
        size: file_size, 
        description: ''
      }
    }]});
  }

  const onUploadFile = (data) => {    
    var ary = (new Array(_.get(data,'sizeArr.length',0))).fill(1);
    ary = ary.map((a,idx) => { return {sid: idx+1,
                        folder: data.fname,
                        fileStep: 'init', //fileStep : step level t which file uploaded
                                          //init : file uploaded at step2 /initial level
                                          //within : file uploaded at step3/within scorm levels
                        title:data.sizeArr[idx].path.substr(0, data.sizeArr[idx].path.length - 4), 
                        sname:data.sizeArr[idx].path, 
                        type: 'Photo',
                        size: {photo : data.sizeArr[idx].size, audio : 0} }
                      });
    props.onUpload({...stepData, step:3, slides: ary, fname: data.fname});
  }
  

  const onSlideSave = (templateData) => {           
    props.onUpload({...stepData, step:3, slides: [{
      sid: 1, 
      type: 'Template', 
      data:{...templateData}
    }]});
  }

  const onBlankCourse = () => props.onUpload({...stepData, step:3, slides: [], blank : true});
  
  return <>
    <div className="heading mb-4">Let's Get Started! Build Your Course.</div>
    {stepData.mode===1 && <StepUploadFile onUpload={onUploadFile} />}
    {stepData.mode===2 && <StepUploadVideo onUpload={onUploadVideo} />}
    {stepData.mode===3 && _.get(stepData,'sprops.chooseLibrary',0)===0 && <StepCustomTemplate onSlideSave={onSlideSave} />}
    {stepData.mode===3 && _.get(stepData,'sprops.chooseLibrary',0)===1 && <StepLibrary onSlideSave={onSlideSave} />}
    {stepData.mode===3 && _.get(stepData,'sprops.blankCourse',0)===1 && <Step3 onSlideSave={onBlankCourse} />}
    {/* {stepData.mode===4 && <StepQuestionForm onSlideSave={onSlideSave} />} */}

  </>;
}

export default Step2;